<template>
  <div>
    <div class="d-flex" :class="!isParent ? 'w-75 ml-auto' : ''">
      <b-avatar
        v-if="getLoggedInUser.first_name && getLoggedInUser.last_name"
        variant="primary"
        size="40px"
        class="ml-2"
        :text="`${getLoggedInUser.first_name[0].toUpperCase()}${getLoggedInUser.last_name[0].toUpperCase()}`"
      />
      <b-avatar variant="primary" size="40px" v-else />
      <div class="w-100 ml-4">
        <form @submit.prevent="onSubmit">
          <textarea
            id="commentText"
            class="form-control mb-3"
            rows="3"
            placeholder="Write feedback..."
            v-model="feedback"
            :disabled="isPosting"
            required
          />
          <div class="text-right mt-2">
            <b-button type="submit" variant="primary" :disabled="isPosting" style="min-width: 100px" class="btn-normal">
              <i v-if="isPosting" class="fas fa-circle-notch fa-spin" />
              <span v-else> Post </span>
            </b-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'post-feedback',

  props: {
    skill: { type: Object, default: () => {} },
    isParent: { type: Boolean, default: false },
    parentFeedbackId: { type: Number, default: null },
    replyToFeedback: { type: Number, default: null },
    replyToMentionName: { type: String, default: null },
  },

  data() {
    return {
      feedback: null,
      isPosting: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
  },
  methods: {
    ...mapActions('feedback', ['createFeedback']),

    async onSubmit() {
      this.isPosting = true;

      try {
        const data = {
          text: this.feedback,
          feedback_by: this.getLoggedInUser.id,
          feedback_on_type: 'studentskillvideo',
          feedback_on_id: this.skill.id,

          ...(this.parentFeedbackId && { parent_feedback: this.parentFeedbackId }),
          ...(this.replyToFeedback && { reply_to_feedback: this.replyToFeedback }),
        };
        await this.createFeedback(data);
        this.feedback = null;
        this.makeToast('success', 'Feedback Created!');
      } catch (error) {
        this.makeToast('danger', this.$t('generalMsgs.genErrorMsg'));
      }
      this.isPosting = false;
      this.$emit('posted');
    },

    makeToast(variant = null, msg) {
      this.$root.$bvToast.toast(msg, {
        variant: variant,
        noCloseButton: true,
        autoHideDelay: 2500,
      });
    },
  },
  async mounted() {
    if (this.replyToMentionName) {
      this.feedback = `@${this.replyToMentionName} `;
    }
  },
};
</script>
